import React, { useState } from 'react';
import { FaClipboard, FaCheckCircle, FaFilePdf, FaUser, FaStethoscope, FaIdCard } from 'react-icons/fa';

const PrescriptionResultsViewer = ({ results, pdfUrl, onBack }) => {
    const [copied, setCopied] = useState(false);

    const copyToClipboard = () => {
        const textToCopy = JSON.stringify(results, null, 2);
        navigator.clipboard.writeText(textToCopy)
            .then(() => {
                setCopied(true);
                setTimeout(() => setCopied(false), 2000);
            })
            .catch(err => {
                console.error('Failed to copy: ', err);
            });
    };

    return (
        <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-2xl">
            <div className="flex justify-between items-center mb-6">
                <h2 className="text-2xl font-bold text-gray-800">Prescription Results</h2>
                <button
                    onClick={onBack}
                    className="text-gray-600 hover:text-gray-800 px-4 py-2 rounded-lg hover:bg-gray-100 transition-all"
                >
                    ← Back
                </button>
            </div>

            <div className="mb-6">
                <div className="flex justify-between items-center mb-2">
                    <h3 className="text-lg font-semibold text-gray-700">Healthcare Institution</h3>
                </div>
                <div className="bg-gray-50 p-4 rounded-lg">
                    <p className="text-lg text-gray-800">
                        {results.healthcareInstitution || "Not detected"}
                    </p>
                </div>
            </div>

            <div className="mb-6">
                <div className="flex justify-between items-center mb-2">
                    <h3 className="text-lg font-semibold text-gray-700">Doctor Information</h3>
                </div>
                <div className="bg-gray-50 p-4 rounded-lg">
                    {results.doctor ? (
                        <div className="space-y-3">
                            {results.doctor.name && (
                                <div className="flex items-center gap-2">
                                    <FaUser className="text-red-500" />
                                    <p className="text-gray-800">
                                        <span className="font-medium">Name: </span>
                                        {results.doctor.name}
                                    </p>
                                </div>
                            )}
                            
                            {results.doctor.specialization && (
                                <div className="flex items-center gap-2">
                                    <FaStethoscope className="text-red-500" />
                                    <p className="text-gray-800">
                                        <span className="font-medium">Specialization: </span>
                                        {results.doctor.specialization}
                                    </p>
                                </div>
                            )}
                            
                            {results.doctor.licenseNumber && (
                                <div className="flex items-center gap-2">
                                    <FaIdCard className="text-red-500" />
                                    <p className="text-gray-800">
                                        <span className="font-medium">License Number: </span>
                                        {results.doctor.licenseNumber}
                                    </p>
                                </div>
                            )}
                        </div>
                    ) : (
                        <p className="text-gray-600">No doctor information available</p>
                    )}
                </div>
            </div>

            <div className="flex flex-col sm:flex-row justify-between items-center gap-4 mt-8">
                <button
                    onClick={() => window.open(pdfUrl, '_blank')}
                    className="w-full sm:w-auto flex items-center justify-center gap-2 px-4 py-2 bg-blue-50 text-blue-600 rounded hover:bg-blue-100 transition-colors"
                >
                    <FaFilePdf /> View Original PDF
                </button>
                
                <button
                    onClick={copyToClipboard}
                    className="w-full sm:w-auto flex items-center justify-center gap-2 px-4 py-2 bg-gray-50 text-gray-700 rounded hover:bg-gray-100 transition-colors"
                >
                    {!copied ? (
                        <>
                            <FaClipboard /> Copy Results
                        </>
                    ) : (
                        <>
                            <FaCheckCircle className="text-green-500" /> Copied!
                        </>
                    )}
                </button>
            </div>
        </div>
    );
};

export default PrescriptionResultsViewer;